// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';


export const getTableSettings = (payload = null) => http.post('apiDashboardCardTool/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiDashboardCardTool/getRows', payload).then(getData);

export const create = (row) => http.post('apiDashboardCardTool/createRow', row).then(getData);

export const update = (row) => http.put('apiDashboardCardTool/editRow&RowID=' + row.ID, row).then(getData);

export const remove = (row) => http.post('apiDashboardCardTool/deleteRow',row).then(getData);

export const getRow = (rowID) => http.get(`apiDashboardCardTool/getRow&RowID=${rowID}`).then(getData);
